export default "__VITE_ASSET__DfB1EueW__"